import { render, staticRenderFns } from "./HolidaysBookingsPrintSticker.vue?vue&type=template&id=1f53bb3f&scoped=true&"
import script from "./HolidaysBookingsPrintSticker.vue?vue&type=script&lang=ts&"
export * from "./HolidaysBookingsPrintSticker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f53bb3f",
  null
  
)

export default component.exports